/* eslint-disable chai-friendly/no-unused-expressions */
import kebabCase from 'lodash.kebabcase';

export const setFormErrorsForScreenReader = formErrors => {
  // US537164 - ADA Form Validation Errors for Screen Readers
  const errorElement = document.querySelector('#readFormErrors');
  if (errorElement) {
    errorElement.innerHTML = '';
  }
  const errorCount = Object.keys(formErrors)?.length;
  document
    .querySelector('#readFormErrors')
    ?.append(`There are ${errorCount} errors in this form: `);
  // append validation error that screen reader should read out
  Object.entries(formErrors).forEach(([key, value]) => {
    if (value === 'Required') {
      document.querySelector('#readFormErrors')?.append(`${key} is Required `);
    } else {
      document.querySelector('#readFormErrors')?.append(`${value} `);
    }
  });
};

export const convertToClassname = (value, prefix = '') => {
  let result = kebabCase(value);

  if (prefix) {
    result = `${prefix}-${result}`;
  }

  return result;
};
